import URL from "../config/api";
import axios from "../config/axios";

export const getShareRoles = async (userRole, token) => {
  const res = await axios.get(`${URL.api}access/role/list`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const roles = res.data.data;

  let shareRoles = [];

  if (userRole.type === "G") {
    shareRoles = roles;
  } else if (userRole.type === "U") {
    shareRoles = roles;
  } else if (userRole.type === "R") {
    shareRoles = roles.filter(role =>
      ["U", "R", "E", "P", "A", "S"].includes(role.type)
    );
  } else if (userRole.type === "E") {
    shareRoles = roles.filter(role =>
      ["R", "E", "P", "A", "S"].includes(role.type)
    );
  } else if (userRole.type === "P") {
    shareRoles = roles.filter(role => ["E", "P", "A", "S"].includes(role.type));
  } else if (userRole.type === "A") {
    shareRoles = roles.filter(role => ["P", "A"].includes(role.type));
  }

  shareRoles = shareRoles.map(role => ({
    role_id: role.id,
    role_name: role.name,
    role_type: role.type,
    group_id: userRole.group_id,
    region_id: userRole.region_id,
    school_id: userRole.school_id
  }));

  return shareRoles;
};

export const friendlySize = bytes => {
  const units = ["bytes", "KB", "MB", "GB", "TB"];
  const index = Math.floor(Math.log2(bytes) / 10);
  const number = (bytes / 1024 ** index).toFixed(1);

  return `${number} ${units[index]}`;
};
